module.exports = __webpack_public_path__ + "media/images/countryrect/au-03b5708cb24034dcdd8b0b6400212688.svg";